module.exports = __webpack_public_path__ + "static/img/lote-retirado.e029037.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/website/leiloes/assets/lote-retirado.jpg
// module id = 162
// module chunks = 18